var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetButtonIcn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "restart_alt_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13971",
    "data-name": "Group 13971"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19615",
    "data-name": "Path 19615",
    d: "M0,0H18V18H0Z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13973",
    "data-name": "Group 13973",
    transform: "translate(3 1.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13972",
    "data-name": "Group 13972"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19616",
    "data-name": "Path 19616",
    d: "M5.5,10.375A4.484,4.484,0,0,1,6.82,7.2L5.755,6.13A6,6,0,0,0,9.25,16.323V14.807A4.505,4.505,0,0,1,5.5,10.375Zm10.5,0a6,6,0,0,0-6-6c-.045,0-.09.008-.135.008l.818-.818L9.625,2.5,7,5.125,9.625,7.75l1.057-1.057-.81-.81c.045,0,.09-.008.128-.008a4.5,4.5,0,0,1,.75,8.932v1.515A5.991,5.991,0,0,0,16,10.375Z",
    transform: "translate(-4 -2.5)",
    fill: "#cdacef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetButtonIcn);
export default __webpack_public_path__ + "static/media/reset-button-icn.89c294612e07b49e2005582f1480ebc0.svg";
export { ForwardRef as ReactComponent };